import { formatBooleanValue } from "../../util";
import Attachment from "../model/Attachment";

const AttachmentMapper = (item: any) => {
  let attachment = Attachment(item);
  attachment.valid = formatBooleanValue(item.valid);
  attachment.anonymised = formatBooleanValue(item.anonymised);
  return attachment;
};

export default AttachmentMapper;
